import ButtonSymphony from 'elements/ButtonSymphony';
import { StyledArticle, StyledBannerDetails, StyledDiv, StyledWarningIcon } from './styles';
import { Subtitle1, Body2, Subtitle2 } from 'components/shareable/Typography';
import Intercom from 'helpers/Intercom';
import Colors from 'modules/Colors';
import Icon from 'elements/Icon';
import { CSSProperties } from 'react';
import { styx } from 'modules/Utils';

export interface SimpleBannerProps {
    title: string;
    description: string;
    ctaLink?: string;
    ctaText?: string;
    intercomArticleId?: string;
    supportMessage?: string;
    ctaComponent?: JSX.Element,
    type: 'issues' | 'note'
}

const FacebookCampaignSimpleBanner = ({
    title,
    description,
    ctaLink,
    ctaText,
    intercomArticleId,
    supportMessage,
    ctaComponent,
    type
}: SimpleBannerProps) => {

    let mainMessage = null
    if (type === 'issues') {
        mainMessage = (
            <StyledDiv>
                <StyledWarningIcon />
                <Subtitle2 color={Colors.yellow}>
                    Issues detected
                </Subtitle2>
            </StyledDiv>
        )
    } else if (type === 'note') {
        mainMessage = (
            <StyledDiv>
                <Subtitle2 color={Colors.yellow}>
                    Campaign Status:
                </Subtitle2>
                <Icon
                    icon="chevronDown"
                    color={Colors.yellow}
                    size={16}
                    className="campaignBannerStatusIcon"
                />
            </StyledDiv>
        )
    }

    return (
        <div className="campaignBannerDetails" style={
            styx(sty.campaignBannerStatusIcon, type === 'issues' ? sty.campaignBannerStatusIcon_issues : sty.campaignBannerStatusIcon_notes)
        }>
            <div className="flex justify-between cursor-pointer mb-2">
                {mainMessage}
            </div>
            <StyledArticle displayBottomBorderLine={false}>
                <div className="flex flex-col gap-1">
                    <Subtitle1>{title}</Subtitle1>
                    <Body2>{description}</Body2>
                </div>
                {ctaComponent && ctaComponent}
                {ctaLink && (
                    <ButtonSymphony
                        className="facebookCampaignSimpleBannerButton"
                        href={ctaLink}
                        target="_blank"
                        rel="noreferrer"
                        variant="text"
                    >
                        {ctaText}
                    </ButtonSymphony>
                )}
                {ctaLink && (
                    <ButtonSymphony
                        className="facebookCampaignSimpleBannerButton"
                        variant="text"
                        href={ctaLink}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {ctaText}
                    </ButtonSymphony>
                )}
                {intercomArticleId && (
                    <ButtonSymphony
                        className="facebookCampaignSimpleBannerButton"
                        onClick={() => Intercom.openArticleWithId(intercomArticleId)}
                        variant="text"
                    >
                        {ctaText}
                    </ButtonSymphony>
                )}
                {supportMessage && (
                    <Subtitle2 color={Colors.yellow}>{supportMessage}</Subtitle2>
                )}
            </StyledArticle>
        </div>
    );
}

const sty: Record<string, CSSProperties> = {
    campaignBannerStatusIcon: {
        marginLeft: 8,
        width: '100%',
        padding: '16 24',
        borderRadius: 8
    },
    campaignBannerStatusIcon_issues: {
        backgroundColor: Colors.PAPER_WARNING_CONTAINER
    },
    campaignBannerStatusIcon_notes: {
        backgroundColor: Colors.greenLight
    }
}
export default FacebookCampaignSimpleBanner;